module.exports = __webpack_public_path__ + "static/media/13c-03_ST-2013-130x90cm-oleo-sobre-papel.0b67d136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13c/13c-03_ST-2013-130x90cm-oleo-sobre-papel.jpg
// module id = 138
// module chunks = 0